module.exports = __webpack_public_path__ + "static/lukas-774c9d5853742d995eed6500ba076de8.jpg";